import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const defaultState = {
  open: {
    confirm: false,
    alert: false
  },
  header: null,
  message: '',
  callback: null,
  cancelCallback: null,
  closeCallback: null,
  canCancel: false,
  confirmText: '',
  noFooter: false,
  showFooterInSecond: -1
}

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations
}
